import { View, Text } from "@react-pdf/renderer";

import { styles } from "../styles";

/**
 * CLE-2659: header block of CMS-R-131 (Exp. 03/31/2029) — patient identification on the left,
 * notifier (the facility issuing the notice) on the right in italics, as the form prints it.
 */
export function PatientSection({
  name,
  accountNumber,
  facilityName,
  fullAddress,
  phoneNumber,
}: {
  name: string;
  accountNumber?: string;
  facilityName?: string;
  fullAddress?: string;
  phoneNumber?: string;
}) {
  return (
    <View style={{ display: "flex", flexDirection: "row", gap: 8 }}>
      <View style={{ width: "55%", display: "flex", flexDirection: "column" }}>
        <Text style={{ ...styles.bodyText, marginBottom: 2 }}>
          <Text style={{ fontFamily: "Helvetica-Bold" }}>Patient name: </Text>
          {name}
        </Text>
        <Text style={{ ...styles.bodyText, marginBottom: 2 }}>
          <Text style={{ fontFamily: "Helvetica-Bold" }}>
            Identification number:{" "}
          </Text>
          {accountNumber}
        </Text>
      </View>
      <View style={{ width: "45%", display: "flex", flexDirection: "column" }}>
        {[facilityName, fullAddress, phoneNumber]
          .filter(Boolean)
          .map((line) => (
            <Text
              key={line}
              style={{
                ...styles.bodyText,
                marginBottom: 2,
                fontFamily: "Helvetica-Oblique",
              }}
            >
              {line}
            </Text>
          ))}
      </View>
    </View>
  );
}
